import Link from 'next/link';
import styles from '../../styles/components/blogs/RelatedPosts.module.css';
import { formatDate } from '../../utils/helpers/blogUtils';

const RelatedPosts = ({ relatedPosts }) => {
    if (!relatedPosts || relatedPosts.length === 0) return null;

    return (
        <aside className={styles.relatedPosts}>
            <Link href="/blogs" className={styles.relatedTitleLink}>
                <h3 className={styles.relatedTitle}>Related Posts</h3>
            </Link>
            <div className={styles.relatedList}>
                {relatedPosts.map((relatedPost, index) => (
                    <div key={index} className={styles.relatedCard}>
                        <Link href={`/blog/${relatedPost.slug}`} className={styles.relatedPostTitleLink}>
                            <h4 className={styles.relatedPostTitle}>{relatedPost.title}</h4>
                        </Link>
                        <p className={styles.relatedPostDescription}>
                            {relatedPost.Description?.substring(0, 100)}...
                        </p>
                        <time className={styles.relatedPostDate}>
                            {formatDate(relatedPost.Date || relatedPost.publishedAt)}
                        </time>
                    </div>
                ))}
            </div>
        </aside>
    );
};

export default RelatedPosts;
